import {
  FontWeight, getTypography, ThemedFunctor, TypographyName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const searchBar: ThemedFunctor = ({ theme }) => css`
  padding: ${theme.remSize[300]};
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[300]};
  border-bottom: 1px solid ${theme.color.border.neutral.default.high};
`;

export const index: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY, { fontWeight: FontWeight.MEDIUM })}
  height: ${theme.remHeight.S};
  display: flex;
  align-items: center;
`;

export const emptySlot = () => css`
  width: 100%;
`;

export const divider: ThemedFunctor = ({ theme }) => css`
  height: 0;
  border-top: 1px solid ${theme.color.border.neutral.default.high};
`;
